export { OnboardingBodyFigure } from "./OnboardingBodyFigure";
export type {
  BodyFigureView,
  OnboardingBodyFigureProps,
} from "./OnboardingBodyFigure";
export {
  DEFAULT_ONBOARDING_BODY_FIGURE_LABELS,
} from "./labels";
export type {
  OnboardingBodyFigureLabels,
  OnboardingBodyFigurePartLabelKey,
} from "./labels";
